var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dcc-loading-overlay",attrs:{"role":"status","aria-label":_vm.$ml.get('dccLoadingTitle')}},[_c('ClipLoader',{attrs:{"loading":true,"color":"#FFFFFF","size":"48px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }